var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F5F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 27C54 29.7614 51.7614 32 49 32C46.2386 32 44 29.7614 44 27H37L27 34.5L32.5 43L37 40V61H45.0567L48.0998 51H60V40L64.5 43L70 34.5L60 27H54Z",
    fill: "#2B5DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27C44 29.7614 46.2386 32 49 32C51.7614 32 54 29.7614 54 27H44Z",
    fill: "#183F9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6233 40.9952H48.3082C48.9795 40.9952 49.4749 40.8947 49.7945 40.6936C50.1142 40.4925 50.274 40.1765 50.274 39.7456C50.274 39.3187 50.1096 39.015 49.7808 38.8345C49.4566 38.6539 48.9521 38.5636 48.2671 38.5636H47.6233V40.9952ZM47.6233 42.5465V46H45.5V37H48.4178C49.7785 37 50.7854 37.2237 51.4384 37.671C52.0913 38.1142 52.4178 38.7893 52.4178 39.6963C52.4178 40.2257 52.2557 40.6977 51.9315 41.1122C51.6073 41.5226 51.1484 41.8447 50.5548 42.0787C52.0616 44.1019 53.0434 45.409 53.5 46H51.1438L48.7534 42.5465H47.6233Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4756 67.0866C72.7947 66.0731 70.9224 65.4622 69.1307 65.4622C64.9807 65.4622 62.5267 68.7394 61.7248 72.7067L61.8077 73C61.8077 73 71.6154 73 74.5 67.1667L74.4756 67.0866Z",
    fill: "#183F9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5244 67.0866C46.2053 66.0731 48.0776 65.4622 49.8693 65.4622C54.0193 65.4622 56.4733 68.7394 57.2752 72.7067L57.1923 73C57.1923 73 47.3846 73 44.5 67.1667L44.5244 67.0866Z",
    fill: "#183F9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4844 64.8333L59.4922 64.8609L59.5 64.8333L61.8034 72.9848C64.1022 68.45 72.106 66.1789 74.4248 67.1154L74.4845 67.1155L69.8846 52H49.0998L44.5 67.1155L44.5597 67.1154C46.8785 66.1789 54.8822 68.45 57.1811 72.9848L59.4844 64.8333Z",
    fill: "#2B5DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingClothes);
export default __webpack_public_path__ + "static/media/TrainingClothes.4a0d49bb4cb82cda5ddf8e1508a2c7ea.svg";
export { ForwardRef as ReactComponent };